import domready from "domready"
import { PerspectiveCamera, Vector3, Matrix4, Frustum, WebGLRenderer } from "three"
import "./style.css"

const PHI = (1 + Math.sqrt(5)) / 2;
const TAU = Math.PI * 2;
const DEG2RAD_FACTOR = TAU / 360;

const config = {
    width: 0,
    height: 0
};

/**
 * @type CanvasRenderingContext2D
 */
let ctx;
let canvas;


function randomAngle(count = 24)
{
    return TAU / count * Math.floor(Math.random() * count)
}

function isCounterclockwise(points)
{
    const x0 = points[0].x
    const y0 = points[0].y
    const x1 = points[1].x
    const y1 = points[1].y
    const x2 = points[2].x
    const y2 = points[2].y

    const det = (x1 - x0) * (y2 - y0) - (x2 - x0) * (y1 - y0)
    return det > 0
}

const ORIGIN = new Vector3(0,0,0)

let cubeCounter = 0

class Cube
{
    id = cubeCounter++
    offset = null
    scale = null

    constructor(x,y,z,xs = 1, ys= 1, zs = 1)
    {
        this.offset = new Vector3(x, y, z)
        this.scale = new Vector3(xs, ys, zs)
    }

    draw(projScreenMatrix)
    {

        const {offset, scale} = this

        const {width, height} = config
        const aspect = width / height
        const cx = width >> 1
        const cy = height >> 1

        const f = 300
        const coords = [
            new Vector3(1, 1, 1),
            new Vector3(1, -1, 1),
            new Vector3(-1, -1, 1),
            new Vector3(-1, 1, 1),
            new Vector3(1, 1, -1),
            new Vector3(1, -1, -1),
            new Vector3(-1, -1, -1),
            new Vector3(-1, 1, -1),
        ]

        const faces = [
            [0, 1, 2, 3],
            [4, 5, 1, 0],
            [7, 6, 5, 4],
            [3, 2, 6, 7],
            [3, 7, 4, 0],
            [2, 1, 5, 6],
        ]

        for (let i = 0; i < faces.length; i++)
        {
            const points = faces[i].map(n => {
                const pt = coords[n].clone().multiply(scale).add(offset).applyMatrix4(projScreenMatrix)

                const x = cx + pt.x * aspect * f / pt.z
                const y = cy - pt.y * f / pt.z

                return new Vector3(x, y, 0)
            })

            if (isCounterclockwise(points))
            {
                const pt = points[points.length - 1]
                ctx.beginPath()
                ctx.moveTo(pt.x, pt.y)
                for (let j = 0; j < points.length; j++)
                {
                    const pt = points[j]
                    ctx.lineTo(pt.x, pt.y)
                }
                ctx.fill()
                ctx.stroke()
            }
        }
    }
}


const cubes = [
    new Cube(0,0,0),
    new Cube(3,0,0),
    new Cube(0,3,0),
    new Cube(0,0,3),
    new Cube(-3,0,0),
    new Cube(0,0,-3),
]


function cubesByDepth(projScreenMatrix)
{
    const c2 = cubes.slice()

    const depths = []

    cubes.forEach(c => {
        depths[c.id] = c.offset.clone().applyMatrix4(projScreenMatrix).z
    })

    c2.sort((a,b) => depths[b.id] - depths[a.id])

    return c2
}


domready(
    () => {

        canvas = document.getElementById("screen");
        ctx = canvas.getContext("2d");

        const width = (window.innerWidth) | 0;
        const height = (window.innerHeight) | 0;

        config.width = width;
        config.height = height;

        canvas.width = width;
        canvas.height = height;

        const cx = width >> 1
        const cy = height >> 1


        const camera = new PerspectiveCamera(60, width / height, 0.1, 1000)

        const paint = () => {

            const camDist = 6
            const camHeight = camDist/4

            let angle = randomAngle()

            const animate = () => {

                camera.position.set(
                    Math.cos(angle) * camDist,
                    camHeight * 3,
                    Math.sin(angle) * camDist,
                )
                camera.lookAt(0,0,0)
                camera.updateMatrix()
                camera.updateProjectionMatrix()
                camera.updateWorldMatrix()


                const projScreenMatrix = new Matrix4()
                projScreenMatrix.multiplyMatrices( camera.projectionMatrix, camera.matrixWorldInverse );

                ctx.fillStyle = "#000";
                ctx.fillRect(0,0, width, height);

                ctx.strokeStyle = "#0c0";
                const c2 = cubesByDepth(projScreenMatrix)

                c2.map(c => c.draw(projScreenMatrix))


                angle += 0.01

                requestAnimationFrame(animate)

            }
            requestAnimationFrame(animate)
        }

        paint()

        canvas.addEventListener("click", paint, true)
    }
);
